import moment from 'moment-timezone'

export default (reference) => (value) => {
  if (reference && value) {
    return moment(value).endOf('day').isAfter(moment(reference).startOf('day'))
  }
  return true
}
